import Vue from 'vue';
import firebase from 'firebase';
export default {
  namespaced: true,
  state: () => ({}),
  actions: {
    trackEvent(undefined, { category = 'user event', action, label, value }) {
      if (action == undefined) {
        throw 'no action provided';
      }
      console.log('track event');
      firebase.analytics().logEvent(action, { label, value });
      Vue.prototype.$ma.trackEvent({ category, action, label, value });
    },
    setAlias(undefined, { userId }) {
      Vue.prototype.$ma.setAlias(userId);
    },
    identify(undefined, { userId }) {
      Vue.prototype.$ma.identify({ userId });
    }
  }
};
